import {DeleteObjectCommand, PutObjectCommand, S3Client,} from "@aws-sdk/client-s3";

import {getSignedUrl} from "@aws-sdk/s3-request-presigner";
import {createConnection} from "./fetch";


export function MyS3() {

    return {


        async shareV(sujet) {
            //
            let sho = true;

const fl=sujet.video;
            const th=sujet.thumb;

            let te = 'Fetching video ';
            const match = fl.match(/\/([^\.]+)\.([a-z0-9]+)$/);
            const match1 = th.match(/\/([^\.]+)\.([a-z0-9]+)$/);
            //return null;
            const ex = '.' + match[2];
            const ex1 = '.' + match[2];
            let fl0;
            let fl1;
            const ext = match[2] != 'png' ? 'video/' + match[2] : 'image/' + match[2];
            const ext1 = match1[2] != 'png' ? 'video/' + match1[2] : 'image/' + match1[2];
            fetch(fl).then(res => res.blob()) // Gets the response and returns it as a blob
                .then(async res => {
                    fl0 = res;

                        fetch(th).then(res1 => res1.blob()) // Gets the response and returns it as a blob
                            .then(async res1 => {


                                fl1 = res1;


// The video get from the MediaRecorder as a Blob


                    /*
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                // var base64data =;

                              }
                         */


                    // reader.readAsDataURL(res);
                    //console.log(res);
                }).finally(async () => {

//new File([fl1], sujet.name + ex1, {type: ext1}),
                const files =[ new File([fl0], sujet.name + ex, {type: ext})];
                            console.log(files);
                navigator.share({
                    files: files,
                    title: sujet.name,
                    url: window.location.href
                })
                    .then(() => {
                        sho = false;
                        te = '';
                    })
                    .catch((error) => {
                        sho = false;
                        console.log(error);
                        te = '';
                    });

            });

                });
            /*



             */

        }

        ,
        async delR2(file) {


            const S3 = new S3Client({
                region: "auto",
                endpoint: process.env.REACT_APP_AWS_ENDPOINT,
                credentials: {
                    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
                    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
                },
            });


            await S3.send(
                new DeleteObjectCommand({
                    Bucket: "vids",
                    Key: file,
                })
            );
        },
            async thumb(path, myFile, type, id) {


            const S3 = new S3Client({
                region: "auto",
                endpoint: process.env.REACT_APP_AWS_ENDPOINT,
                credentials: {
                    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
                    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
                },
            });

console.log(S3)
            getSignedUrl(
                S3,
                new PutObjectCommand({
                    Bucket: 'vids',
                    Key: path,
                }),
                {
                    expiresIn: 60 * 60 * 24 * 7, // 7d
                }
            ).then((url) => {

                const tp = type.split('/')[1];

                const typ = tp == 'png' ? 'thumb' : 'video';
                const requestOptions = {
                    method: 'PUT',
                    headers: {'Content-Type': type},
                    body: myFile
                };
                try {
                    fetch(url, requestOptions)
                        .then(data => {

                            data.ok && createConnection().update('sujet', id, tp == 'png' ? {thumb: 'https://vids.memigration.info/' + path} : {video: 'https://vids.memigration.info/' + path});


                        }).catch((e) => console.log(e))
                } catch (e) {
                    console.log(e);

                }

                /*
                http.put(url,
                  myFile,
                  {
                    headers: new HttpHeaders({
                      'Content-Type': type
                    })
                  }).subscribe(ed=>{

                  console.log(ed);

                });
            */

            })


        }
    }
}
